/**
 * 模块名称：猎企 入驻/绑定 流程
 * @author ：XXXXX
 */
import { Toast } from 'vant'
import Cookies from 'js-cookie'
import {
  getConsultantCompany,
  getSearchCompany,
  getGoodAtDirection,
  getGetEmailCode,
  getBindConsultantCompany,
  getCompanyInfoVerify,
  getCompanyInfoRedisplay,
  getCompanyCertificationLink,
  getCompanyAuthStatus,
  getCompanyAuthorizationLink,
  getCompanyAuthorizationInformation,
  getLegalPersonAuth,
  getContractLink,
  getContractSignStatus,
  getAbandonRegister,
  getUserDetail,
  getCompanyAuthorizationStatus,
  getCheckCompanyAuthStatus,
  getCheckEmailCode,
  getRealNameIdentify,
  getPersonalCenterFunctionInfo,
  getBusinessType,
  getIndustryInfo,
  getCityList,
} from '@/api/joinEnterprise'
import { getUploadBusinessLicense } from '@/api'
const state = {
  companyList: [],
  companyListCount: 0,
  gooodAtList: '',
  companyNameData: '',
  noHaveTips: '',
  rdplay: '',
  certificationData: '',
  companyAuthStatus: '',
  contractLink: '',

  CompanyAuthorizationInformation: {},
  legalPersonAuth: {},
  contractSignStatus: '',
  authorizationStatus: '',
  license: '',
  cityList: [], // 擅长城市
  industryList: [], // 擅长行业
  postList: [], // 擅长职能
  businessTypeList: [], // 擅长业务类型
}
const mutations = {
  /**
   * 为state项赋值
   * @param state
   * @param data
   */
  setStateItem(state, data) {
    state[data.key] = data.value
  },
}

const actions = {
  // 查询猎企（绑定猎企时使用）
  async requestConsultantCompany({ state, commit }, data) {
    try {
      const res = await getConsultantCompany(data)
      if (res.data.code == 200) {
        data.cb && data.cb()
        commit('setStateItem', {
          key: 'companyList',
          value: res.data.data.data,
        })
        commit('setStateItem', {
          key: 'companyListCount',
          value: res.data.data.count,
        })
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },
  // 擅长方向标签
  async requestGoodAtDirection({ state, commit }, data) {
    try {
      const res = await getGoodAtDirection(data)
      if (res.data.code == 200) {
        commit('setStateItem', { key: 'gooodAtList', value: res.data.data })
        data.cb && data.cb()
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },

  // 天眼查查询公司注册信息（创建新客户） cyp
  async requestSearchCompany({ state, commit }, data) {
    try {
      commit('setStateItem', { key: 'noHaveTips', value: '' })
      // commit("setStateItem", { key: "companyNameData", value: '' });
      const res = await getSearchCompany(data)
      if (res.data.code == 200) {
        commit('setStateItem', { key: 'companyNameData', value: res.data.data })
      } else {
        if (res.data.errorCode == 400) {
          commit('setStateItem', {
            key: 'noHaveTips',
            value: '请输入正确公司名称',
          })
        }
      }
    } catch (e) {
      return false
    }
  },

  // 获取邮箱验证码
  async requestGetEmailCode({ state, commit }, data) {
    try {
      const res = await getGetEmailCode(data)
      if (res.data.code == 200) {
        data.cb && data.cb()
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },

  // 绑定猎企cyp
  async requestBindConsultantCompany({ state, commit }, data) {
    try {
      const res = await getBindConsultantCompany(data)
      if (res.data.code == 200) {
        data.cb && data.cb()
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },
  // 获取完善信息回显数据cyp
  async requestCompanyInfoRedisplay({ state, commit }, data) {
    try {
      const res = await getCompanyInfoRedisplay(data)
      if (res.data.code == 200) {
        commit('setStateItem', { key: 'rdplay', value: res.data.data })
        data.cb && data.cb(res.data.data)
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },

  // 猎企信息校验cyp
  async requestCompanyInfoVerify({ state, commit }, data) {
    try {
      const res = await getCompanyInfoVerify(data)
      if (res.data.code == 200) {
        let arr = res.data.data
        data.suc && data.suc(arr)
        return false
      } else {
        // data.fail && data.fail();
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },

  // 获取企业认证链接cyp
  async requestCompanyCertificationLink({ state, commit }, data) {
    try {
      data.is_h5 = 1
      const res = await getCompanyCertificationLink(data)
      if (res.data.code == 200) {
        commit('setStateItem', { key: 'certificationData', vlaue: data.data })
        data.suc && data.suc(res.data.data)
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },
  // 放弃注册cyp
  async requestAbandonRegister({ state, commit }, data) {
    try {
      const res = await getAbandonRegister(data)
      if (res.data.code == 200) {
        if (res.data.data.status == 0) {
          Toast('放弃失败')
        } else {
          data.suc && data.suc(res.data.data)
        }
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },
  // 法人验证 cyp
  async requestLegalPersonAuth({ state, commit }, data) {
    try {
      const res = await getLegalPersonAuth(data)
      if (res.data.code == 200) {
        commit('setStateItem', { key: 'legalPersonAuth', value: res.data.data })
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },
  // 获取企业认证结果
  async requestCompanyAuthStatus({ state, commit }, data) {
    try {
      const res = await getCompanyAuthStatus(data)
      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'companyAuthStatus',
          value: res.data.data,
        })
        return true
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },
  // 获取企业认证授权结果 cyp
  async requestCompanyAuthorizationInformation({ state, commit }, data) {
    try {
      const res = await getCompanyAuthorizationInformation(data)
      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'CompanyAuthorizationInformation',
          value: res.data.data,
        })
        data.suc && data.suc(res.data.data)
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },

  // 获取签署合同链接cyp
  async requestContractLink({ state, commit }, data) {
    try {
      const res = await getContractLink(data)
      if (res.data.code == 200) {
        commit('setStateItem', { key: 'contractLink', value: res.data.data })
        data.suc && data.suc(res.data.data)
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },

  // 禾蛙企业授权链接cyp
  async requestCompanyAuthorizationLink({ state, commit }, data) {
    try {
      const res = await getCompanyAuthorizationLink(data)
      if (res.data.code == 200) {
        data.suc && data.suc(res.data.data)
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },
  // 获取合同签署结果5cyp
  async requestContractSignStatus({ state, commit }, data) {
    try {
      const res = await getContractSignStatus(data)
      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'contractSignStatus',
          value: res.data.data,
        })
        return true
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },
  // 获取企业认证授权结果8cyp
  async requestCompanyAuthorizationStatus({ state, commit }, data) {
    try {
      const res = await getCompanyAuthorizationStatus(data)
      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'authorizationStatus',
          value: res.data.data,
        })
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },

  // 验证猎企状态接口
  async requestCheckCompanyAuthStatus({ state, commit }, data) {
    try {
      const res = await getCheckCompanyAuthStatus(data)
      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'authorizationStatus',
          value: res.data.data,
        })
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },
  // 获取顾问信息7
  async requestUserDetail({ state, commit }, data) {
    try {
      const res = await getUserDetail(data)
      if (res.data.code == 200) {
        // commit("setStateItem", { key: "companyAuthStatus", value: res.data.data });
        return true
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },
  /*
           营业执照上传
        */
  async requestuploadBusinessLicense({ state, commit }, data) {
    try {
      const res = await getUploadBusinessLicense(data)

      if (res.data.code == 200) {
        commit('setStateItem', { key: 'license', value: res.data.data })
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },
  setLicense({ commit }, data) {
    commit('setStateItem', { key: 'license', value: data })
  },
  // 邮箱提交
  async getCheckEmailSubmit({ state, commit }, data) {
    try {
      const res = await getCheckEmailCode(data)
      if (res.data.code == 200) {
        data.cb && data.cb()
        return false
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      return false
    }
  },
  //姓名 身份证号提交
  async getRealNameIdentify({ state, commit }, data) {
    try {
      const res = await getRealNameIdentify(data)
      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'postList',
          value: res.data.data,
        })
        data.cb && data.cb(res.data.data)
      } else {
        Toast(res.data.message)
      }
    } catch (e) {
      console.log(e)
    }
  },

  // 擅长职能
  async getPersonalCenterFunctionInfo({ state, commit }, data) {
    try {
      const res = await getPersonalCenterFunctionInfo(data)
      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'postList',
          value: res.data.data,
        })
        data.cb && data.cb(res.data.data)
      } else {
        Toast(res.data.message)
      }
    } catch (e) {
      console.log(e)
    }
  },
  // 擅长业务类型
  async getBusinessType({ state, commit }, params) {
    try {
      let hot = params.hot
      delete params.hot
      const res = await getBusinessType(params)
      if (res.data.code == 200) {
        let data = res.data.data
        if (hot == 1) {
          data.pop()
        }
        commit('setStateItem', {
          key: 'businessTypeList',
          value: data,
        })
        params.cb && params.cb(data)
      } else {
        Toast(res.data.message)
      }
    } catch (e) {
      console.log(e)
    }
  },
  // 擅长行业
  async getIndustryInfo({ state, commit }, data) {
    try {
      const res = await getIndustryInfo(data)
      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'industryList',
          value: res.data.data,
        })
        data.cb && data.cb(res.data.data)
      } else {
        Toast(res.data.message)
      }
    } catch (e) {
      console.log(e)
    }
  },
  // 擅长城市
  async getCityList({ state, commit }, params) {
    try {
      let hot = params.hot
      delete params.hot
      const res = await getCityList(params)
      if (res.data.code == 200) {
        let data = res.data.data
        if (hot == 1) {
          data.shift()
        }
        commit('setStateItem', {
          key: 'cityList',
          value: data,
        })
        params.cb && params.cb(data)
      } else {
        Toast(res.data.message)
      }
    } catch (e) {
      console.log(e)
    }
  },
}

export default {
  state,
  actions,
  mutations,
  namespaced: true,
}
